import DetailedClaimant from "./DetailedClaimant";

export default DetailedClaimant;